import React from "react";
import * as Yup from "yup";
import { Grid, Paper } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import {
  getAllClientsNoPagination,
  workflowContainerFullById,
  workflowContainerFullPost,
  workflowContainerFullPut,
} from "../../../../libs/apis";
import { useSnackbar } from "@components";
import {
  Button as ButtonAntd,
  ConfigProvider,
  message,
  Popconfirm,
  Segmented,
  Space,
} from "antd";
import { CheckCircleFilled, ClearOutlined } from "@ant-design/icons";
import { ClientI } from "../../../../libs/interfaces";
import { ThirdComponent } from "./thrid-component/page";
import { useLocalStorage, useWidth } from "../../../../libs/hooks";
import imageBg from "../../../../images/bg-equipments.jpg";
import { NAVBAR_HEIGHT_SUM } from "../../../../libs/constants";
import { useWorkflowContainerFullStore } from "../../store";
import { css } from "@emotion/css";
import { FirstComponent } from "./first-component";
import { useShallow } from "zustand/react/shallow";
import { SecondComponent } from "./second-component/page";
import { useRouterStore } from "../../../../libs/stores";
import Swal from "sweetalert2";
import { obtenerFotoConWatermarkBase64 } from "../../../../libs/hooks";

const WorkflowAddComponent = () => {
  const width = useWidth();

  return (
    <Grid
      container
      spacing={0.5}
      justifyContent="center"
      sx={{
        mt: 0,
        maxHeight: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        minHeight: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        height: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        overflowY: "hidden",
        overflowX: "hidden",
        backgroundImage: `url(${imageBg})`,
      }}
    >
      <Grid item xs={12} md={6}>
        <Paper elevation={2} sx={{ m: width === "xs" ? 0 : 1 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Component width={width} />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

interface ComponentPropsI {
  width: string;
}
const Component = ({ width }: ComponentPropsI) => {
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const setSection = useRouterStore((state) => state.setSection);

  const [clients, setClients] = React.useState<ClientI[]>([]);
  const step = useWorkflowContainerFullStore((state) => state.step);

  const setDataContainerFull = useWorkflowContainerFullStore(
    (state) => state.setDataContainerFull
  );

  const onClear = useWorkflowContainerFullStore(
    useShallow((state) => state.onClear)
  );
  const [activeKey, setActiveKey] = useLocalStorage<string[]>(
    "active-key-full",
    ["1"]
  );

  React.useEffect(() => {
    handleGetData();
    setSection("Full 🚚");

    return () => {
      setSection("");
      if (id) {
        onClear();
        setActiveKey(["1"]);
      }
    };
  }, []);

  const handleGetData = async () => {
    try {
      if (id) {
        const { data: dataWf } = await workflowContainerFullById(Number(id));
        if (!dataWf) return;

        setDataContainerFull(dataWf);
      }

      const { data: dataClients } = await getAllClientsNoPagination();
      if (!dataClients) return;
      setClients(dataClients);
    } catch (err) {
      console.log(err);
      enqueueSnackbar(err!.toString(), { variant: "error" });
    }
  };

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        overflowY: "hidden",
        overflowX: "hidden",
      }}
    >
      <HeaderComponent
        width={width}
        id={id}
        setActiveKey={setActiveKey}
        enqueueSnackbar={enqueueSnackbar}
      />
      {step === "Formulario" ? (
        <FirstComponent clients={clients} width={width} />
      ) : step === "Códigos" ? (
        <SecondComponent widthFull={width} />
      ) : step === "Fotos" ? (
        <ThirdComponent
          width={width}
          activeKey={activeKey}
          setActiveKey={setActiveKey}
        />
      ) : (
        <FirstComponent clients={clients} width={width} />
      )}
    </div>
  );
};

interface HeaderPropsI {
  width: string;
  id: string | undefined;
  setActiveKey: (key: any) => void;
  enqueueSnackbar: (message: string, options?: any) => void;
}

const HeaderComponent = ({
  width,
  id,
  setActiveKey,
  enqueueSnackbar,
}: HeaderPropsI) => {
  const navigate = useNavigate();
  const { getPrefixCls } = React.useContext(ConfigProvider.ConfigContext);
  const rootPrefixCls = getPrefixCls();
  const [isProcessing, setProcessing] = React.useState(false);
  const firstTakePhoto = useWorkflowContainerFullStore(
    (state) => state.firstTakePhoto
  );
  const onClear = useWorkflowContainerFullStore((state) => state.onClear);
  const resetSteps = useWorkflowContainerFullStore((state) => state.resetSteps);
  const getOnlyPhotos = useWorkflowContainerFullStore(
    (state) => state.getOnlyPhotos
  );

  const validationSchema = Yup.object({
    container: Yup.string().required("N° Contenedor Requerido"),
    clientId: Yup.string().required("Exportador Requerido"),
    producerId: Yup.string().required("Productor Requerido"),
    farmId: Yup.string().required("Hacienda Requerida"),
    magap: Yup.string().required("Magap Requerido"),
    boxId: Yup.string().required("Tipo de Caja Requerido"),
    brandId: Yup.string().required("Marca Requerido"),

    closeProcess: Yup.string().required("Hora Cierre de Proceso Requerido"),
    endLoading: Yup.string().required("Hora Fin de Carga Requerido"),
    containerClose: Yup.string().required(
      "Hora Cierre de Contenedor Requerido"
    ),
    containerOulet: Yup.string().required(
      "Hora Salida de Contenedor Requerido"
    ),

    numKit: Yup.string().required("Número de Kit Full"),
    adhesivo: Yup.string().required("Adhesivo  requerido"),
    adhesivoBisagra: Yup.string().required("Adhesivo Bisagra requerido"),
    adhesivoBisagraPhoto1: Yup.string().required(
      "Adhesivo Bisagra Foto1 requerido"
    ),
    adhesivoBisagraPhoto2: Yup.string().required(
      "Adhesivo Bisagra Foto2 requerido"
    ),
    adhesivoBisagraPhoto3: Yup.string().required(
      "Adhesivo Bisagra Foto3 requerido"
    ),
    adhesivoPhoto: Yup.string().required("Adhesivo Foto requerido"),
    adhesivoPuerta: Yup.string().required("Adhesivo Puerta requerido"),
    adhesivoPuertaPhoto: Yup.string().required(
      "Adhesivo Puerta Foto requerido"
    ),
    botellaExpor: Yup.string().required("Botella Expor requerido"),
    botellaExporPhoto: Yup.string().required("Botella Expor Foto requerido"),
    botellaNaviera: Yup.string().required("BotellaNaviera requerido"),
    botellaNavieraPhoto: Yup.string().required("BotellaNaviera Foto requerido"),
    botellaVerificadoraRastreo: Yup.string().required(
      "BotellaVerificadoraRastreo requerido"
    ),
    botellaVerificadoraRastreoPhoto: Yup.string().required(
      "BotellaVerificadoraRastreo Foto requerido"
    ),
    cableExpor: Yup.string().required("Cable Expor requerido"),
    cableExporPhoto: Yup.string().required("Cable Expor Foto requerido"),
    cableVerificadora: Yup.string().required("Cable Verificadora requerido"),
    cableVerificadoraPhoto: Yup.string().required(
      "Cable Verificadora Foto requerido"
    ),
    evaluacionFruta: Yup.string().required("Evaluacion Fruta requerido"),
    evaluacionFrutaPhoto: Yup.string().required(
      "Evaluacion Fruta Foto requerido"
    ),
    guiaTransporte: Yup.string().required("Guia de Transporte requerido"),
    guiaTransportePhoto: Yup.string().required(
      "Guia de Transporte Foto requerido"
    ),
    numCajas: Yup.string().required("Numero de Cajas requerido"),
    numRastreoSatelital: Yup.string().required(
      "Num Rastreo Satelital requerido"
    ),
    numRastreoSatelitalPhoto: Yup.string().required(
      "Num Rastreo Satelital Foto requerido"
    ),
    siglasFPhoto: Yup.string().required("Foto Contenedor Full requerido"),
    tarjaCarga: Yup.string().required("Tarja Carga requerido"),
    tarjaCargaPhoto: Yup.string().required("Tarja Carga Foto requerido"),
    termografo: Yup.string().required("Termografo requerido"),
    termografoPhoto: Yup.string().required("Termografo Foto requerido"),
    cajasConsolidadasPhoto1: Yup.string().required(
      "Caja Consolidada Foto 1 requerido"
    ),
    cajasConsolidadasPhoto2: Yup.string().required(
      "Caja Consolidada Foto 2 requerido"
    ),
    cajasConsolidadasPhoto3: Yup.string().required(
      "Caja Consolidada Foto 3 requerido"
    ),
    cajasConsolidadasPhoto4: Yup.string().required(
      "Caja Consolidada Foto 4 requerido"
    ),
    cajasConsolidadasPhoto5: Yup.string().required(
      "Caja Consolidada Foto 5 requerido"
    ),
    cierreContenedorPhoto1: Yup.string().required(
      "Cierre Contenedor Foto 1 requerido"
    ),
    cierreContenedorPhoto2: Yup.string().required(
      "Cierre Contenedor Foto 2 requerido"
    ),
    cierreContenedorPhoto3: Yup.string().required(
      "Cierre Contenedor Foto 3 requerido"
    ),
    ventoleraIzquierdaPhoto: Yup.string().required(
      "Ventolera Izquierda Foto requerida"
    ),
    ventoleraDerechaPhoto: Yup.string().required(
      "Ventolera Derecha Foto requerida"
    ),
    panelIzquierdoPhoto: Yup.string().required(
      "Panel Izquierdo Foto requerida"
    ),
    panelDerechoPhoto: Yup.string().required("Panel Derecho Foto requerida"),
  });

  const getDataContainerFull = useWorkflowContainerFullStore(
    (state) => state.getDataContainerFull
  );

  const linearGradientButton = css`
    &.${rootPrefixCls}-btn-primary:not([disabled]):not(
        .${rootPrefixCls}-btn-dangerous
      ) {
      border-width: 0;

      > span {
        position: relative;
      }

      &::before {
        content: "";
        background: linear-gradient(135deg, #6253e1, #04befe);
        position: absolute;
        inset: 0;
        opacity: 1;
        transition: all 0.3s;
        border-radius: inherit;
      }

      &:hover::before {
        opacity: 0;
      }
    }
  `;

  async function buildFinalData() {
    const dateHelper = new Date();

    const data = { ...getOnlyPhotos() };
    const dataTotal = { ...getDataContainerFull() };
    dataTotal.timeStampSave = firstTakePhoto ?? dateHelper.toISOString();
    dataTotal.hourSaveUser = dateHelper.toLocaleTimeString();

    for (const [clave, valor] of Object.entries(data)) {
      if (
        !valor ||
        valor.startsWith("http://") ||
        valor.startsWith("https://") ||
        valor.startsWith("data:")
      )
        continue;
      data[clave] = await obtenerFotoConWatermarkBase64(valor as string);
    }

    return { ...dataTotal, ...data };
  }

  const handleSave = async () => {
    try {
      setProcessing(true);
      message.loading("Procesando las fotos", 0);
      const objPost = await buildFinalData();
      await validationSchema.validate(objPost);
      message.destroy();
      message.loading("Guardando Información", 0);

      if (id) {
        const { data: dataPut } = await workflowContainerFullPut(
          Number(id),
          // getDataContainerFull();
          objPost
        );
        if (!dataPut) return;
        message.destroy();
        message.success(dataPut);
      } else {
        const { data: dataPost } = await workflowContainerFullPost(objPost);
        if (!dataPost) return;
        message.destroy();
        Swal.fire({
          title: "¡Registro exitoso!",
          icon: "success",
          text: dataPost.alert,
          confirmButtonText: "Aceptar",
        });
      }
      resetSteps();
      // onClear();
      navigate("/container/full/list");
      setActiveKey(["1"]);
      setProcessing(false);
    } catch (err: any) {
      message.destroy();
      setProcessing(false);
      enqueueSnackbar(err.toString(), { variant: "error" });
    }
  };

  const handleResetWithFear = () => {
    Swal.fire({
      title: "¡Atención!",
      html: `<p style="font-weight:bolder; color:red">Estás a punto de BORRAR todo. <br/> ¿Estás seguro?</p>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar todo",
      cancelButtonText: "No, cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        onClear();
        resetSteps();
        Swal.fire({
          title: "¡Listo!",
          text: "Toda la información fue borrada",
          icon: "success",
          confirmButtonColor: "#271080",
        });
      }
    });
  };

  return (
    <div
      style={{
        position: "absolute",
        top: width === "xs" ? -7 : -8,
        width: "100%",
        height: 50,
        background: "white",
        zIndex: 701,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        alignContent: "center",
        padding: 0.5,
        borderBottom: "1px dashed gainsboro",
      }}
    >
      <StepComponent />
      <div>
        <ConfigProvider
          button={{
            className: linearGradientButton,
          }}
        >
          <Space size="small">
            <Popconfirm
              title="Se borrará toda la Información"
              description="Desea Continuar?"
              onConfirm={handleResetWithFear}
              zIndex={1601}
              okText="Si"
              cancelText="No"
              okButtonProps={{ size: "middle", style: { fontWeight: "bold" } }}
              cancelButtonProps={{ size: "middle" }}
            >
              <ButtonAntd
                size="middle"
                type="primary"
                danger
                icon={<ClearOutlined />}
              />
            </Popconfirm>
            <Popconfirm
              title="Finalizar Proceso"
              description="Si Finaliza no podrá editar la Información"
              onConfirm={handleSave}
              okText="Si"
              cancelText="No"
              okButtonProps={{ size: "middle", style: { fontWeight: "bold" } }}
              cancelButtonProps={{ size: "middle" }}
              icon={<CheckCircleFilled />}
              zIndex={1601}
            >
              <ButtonAntd
                size="middle"
                loading={isProcessing}
                type="primary"
                icon={<CheckCircleFilled />}
                disabled={isProcessing}
              >
                Finalizar
              </ButtonAntd>
            </Popconfirm>
          </Space>
        </ConfigProvider>
      </div>
    </div>
  );
};

const StepComponent = () => {
  const step = useWorkflowContainerFullStore((state) => state.step);
  const setStep = useWorkflowContainerFullStore((state) => state.setStep);

  return (
    <Segmented
      options={["Formulario", "Códigos", "Fotos"]}
      value={step}
      onChange={setStep}
    />
  );
};

export default WorkflowAddComponent;
